import React from 'react'
import ReactDOM from 'react-dom'
import APP from './views/App'
import eventBus from '../../../../../util/eventBus'
import BtnBar from "./views/btnBar/index";
import { Button, Select, Icon } from '@kdcloudjs/kdesign'

const normalScheme = { id: "NScheme", schemeName: "常用条件过滤", default: false };

(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----filt init', props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----filt update', props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      // console.log('-----destoryed', this.model)
      ReactDOM.unmountComponentAtNode(this.model.dom)
    }
  }

  const setHtml = function (model, primaryProps) {
    KDApi.loadFile('./css/index.css', model, () => {

      class Root extends React.Component {
        constructor(props) {
          super(props)

          const data = props?.customProps?.data ?? null

          this.state = {
            model: props.model,
            btnParams: {
              hasCardEditPerm: data?.hasCardEditPerm ?? 0,
              hasChartExportPerm: data?.hasChartExportPerm ?? 0,
            },
            editStatus: false,
            searchLoading: false,
            filtParams: {
              ... this.makeInitParams(data)
            },
            maxLevel: parseInt(data?.maxLevel ?? 1),
            showOrgTeam: data?.showOrgTeam ?? null,
            showScheme: data?.showScheme ?? normalScheme,
            schemes: [normalScheme, ...(data?.schemes ?? [])]
          }

          this.initSingleEvent()

          this.initMyInvoke(props.model)
        }

        componentDidMount() {
          const { model } = this.state
          this.updateSub = eventBus.sub(model, 'update', (updateProps) => {

            const data = updateProps?.data ?? null

            const eventType = data?.orgChart ?? ""

            this.handleMyInvoke(eventType, updateProps)

            this.handleSingleEvent(eventType, updateProps)

            console.log("update data", data);

            switch (eventType) {
              // 初始化参数
              case "initParamsKey":
                const btnParams = {
                  hasCardEditPerm: data?.hasCardEditPerm ?? 0,
                  hasChartExportPerm: data?.hasChartExportPerm ?? 0
                }

                this.setState({
                  btnParams,
                  filtParams: {
                    ...this.makeInitParams(data)
                  },
                  maxLevel: parseInt(data?.maxLevel ?? 1),
                  showScheme: data?.showScheme ?? normalScheme,
                  schemes: [normalScheme, ...(data?.schemes ?? [])]
                })
                break;
              case "commonConditionQuery":
              case "queryTreeNodeData":
                this.setState({
                  filtParams: this.makeInitParams(data),
                  showOrgTeam: data?.showOrgTeam ?? null,
                  maxLevel: data?.maxLevel ?? 1,
                  searchLoading: false
                })
                break;
              case "refreshOrgChart":
                this.setState({
                  filtParams: this.makeInitParams(data),
                  showOrgTeam: data?.showOrgTeam ?? null,
                  searchLoading: false
                })
                break;
              case "openAdminOrgTypeF7":
                this.setState((state, props) => {
                  state.filtParams.showAdminOrgTypes = data?.showAdminOrgTypes ?? []
                  return {
                    filtParams: { ...state.filtParams }
                  }
                })
                break;
              case "changeQueryCondition":
                this.setState((state, props) => {
                  state.filtParams.hasPersonalStyle = data?.hasPersonalStyle ?? 0
                  state.filtParams.personalStyle = data?.personalStyle ?? null
                  state.filtParams.showLevel = parseInt(data?.showLevel ?? 1)
                  return {
                    filtParams: { ...state.filtParams },
                    showOrgTeam: data?.showOrgTeam ?? null,
                    maxLevel: parseInt(data?.maxLevel ?? 1),
                  }
                })
                break;
              case "queryError":
                this.setState({
                  searchLoading: false
                })
                break;
              case "dataRouteKey":
                const routeData = JSON.parse(data.data ?? "")
                switch (routeData.eventName) {
                  case "youCanParamsKey":
                    model.invoke("initParamsKey")
                    break;
                  case "makeIndiviSuccess":
                    this.setState((state, props) => {
                      state.filtParams.personalStyle = routeData?.personalStyle ?? null
                      state.filtParams.isOpenPersonalStyle = true

                      return {
                        filtParams: state.filtParams,
                        editStatus: false
                      }
                    })
                    break;
                  case "exitEdit":
                    this.setState({ editStatus: false })
                    break;
                  case "saveAsIndiviSuccess":
                    // 保存个性化成功
                    this.setState((state, props) => {
                      state.filtParams.personalStyle = routeData?.personalStyle ?? null

                      return {
                        filtParams: state.filtParams,
                      }
                    })
                    break;
                }
                break;
              case "savePersonalStyle":
                this.setState((state, props) => {
                  state.filtParams.hasPersonalStyle = 1
                  return {
                    filtParams: { ...state.filtParams }
                  }
                })
                break;
            }
          })
        }

        componentWillUnmount() {
          eventBus.unsub(this.updateSub)
        }

        makeInitParams(data = null) {
          console.log("makeInitParams", data);
          return {
            orgs: data?.orgs ?? [], //主管责任单位
            queryDate: data?.queryDate ?? new Date(),
            chartStyle: data?.MATCH_CHART_STYLE_KEY ?? null, //结构图样式

            hasPersonalStyle: data?.hasPersonalStyle ?? 0,
            isOpenPersonalStyle: data?.isOpenPersonalStyle ?? 0,
            personalStyle: data?.personalStyle ?? null,

            orgchartdirection: data?.orgchartdirection ?? "1",
            showLevel: parseInt(data?.showLevel ?? 1),

            showOtclassifys: data?.showOtclassifys ?? null,  //团队分类
            showAdminOrgTypes: data?.showAdminOrgTypes ?? [],   //组织类型
            showCooprelTypes: data?.showCooprelTypes[0] ?? null,  //协作关系
          }
        }

        initMyInvoke(model) {
          this.updateCallBackMap = {}

          this.myInvoke = (key, params, cbKey) => {
            return new Promise((resolve, reject) => {
              model.invoke(key, params)
              if (cbKey) {
                this.updateCallBackMap[cbKey] = updateProps => {
                  const data = updateProps?.data ?? null
                  const code = data?.code ?? ""
                  if (code === "200") {
                    resolve(data)
                  } else {
                    reject(data)
                  }
                }
              } else {
                resolve(null)
              }
            })
          }
        }

        handleMyInvoke(eventType, eventProps) {
          if (this.updateCallBackMap[eventType]) {
            this.updateCallBackMap[eventType](eventProps)
            return true
          }
          return false
        }

        initSingleEvent() {
          this.singleEventMap = {}

          this.makeSingleEvent = (key, event) => {
            this.singleEventMap[key] = function (updateProps) {
              const data = updateProps?.data ?? null
              const code = data?.code ?? ""
              if (code === "200") {
                event(data)
              } else {
                console.error("请求错误");
              }
            }
          }
        }

        handleSingleEvent(eventType, eventProps) {
          if (this.singleEventMap[eventType]) {
            this.singleEventMap[eventType](eventProps)
            return true
          }
          return false
        }

        updateState = (key, val) => {
          this.setState({
            [key]: val
          })
        }

        refreshPage = () => {
          this.state.model.invoke("refreshOrgChart", this.getFullParams())
        }

        getFullParams = () => {
          const filtParams = this.state.filtParams
          const params = {
            adminorgtypes: (filtParams?.showAdminOrgTypes ?? []).map(item => item.id),
            coopreltypes: [filtParams?.showCooprelTypes?.id ?? null],
            orgchartdirection: filtParams?.orgchartdirection ?? "1",
            showlevel: (filtParams?.showLevel ?? "") + "",
            currentOrgChartRootNodeId: this.state.showOrgTeam?.id ?? null,
            chartStyleId: filtParams?.chartStyle?.id ?? null,
            datefield: filtParams?.queryDate,
            queryDate: filtParams?.queryDate,
            orgs: (filtParams?.orgs ?? []).map(item => item.id),
            teamotclassify: (filtParams?.showOtclassifys ?? []).map(item => item.id),
            personalStyleId: filtParams?.personalStyle?.id ?? null,
            isOpenPersonalStyle: filtParams?.isOpenPersonalStyle ?? false
          }

          console.log("参数", params);

          return params
        }

        render() {
          const { filtParams, schemes, btnParams, model,
            editStatus, showOrgTeam, searchLoading, showScheme, maxLevel
          } = this.state
          const myInvoke = this.myInvoke
          const updateState = this.updateState
          const makeSingleEvent = this.makeSingleEvent

          return (
            <div className='filt-container' style={{ marginBottom: editStatus ? "10px" : "0" }}>
              <BtnBar model={model}
                myInvoke={myInvoke}
                direction={filtParams?.orgchartdirection ?? "1"}
                currentNodeIsNull={!showOrgTeam}
                isOpenPersonalStyle={filtParams?.isOpenPersonalStyle ?? false}
                btnParams={btnParams}
                editStatus={editStatus}
                updateState={updateState}
                refreshPage={this.refreshPage}
              />
              <APP model={model}
                myInvoke={myInvoke}
                searchLoading={searchLoading}
                schemes={schemes}
                filtParams={filtParams}
                maxLevel={maxLevel}
                showOrgTeam={showOrgTeam}
                showScheme={showScheme}
                updateState={updateState}
                makeSingleEvent={makeSingleEvent}
                editStatus={editStatus}
                makeInitParams={this.makeInitParams}
                getFullParams={this.getFullParams}
              />
            </div>
          )
        }
      }

      ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)
    })
  }

  // 注册自定义组件
  KDApi.register('kdchart2filt', MyComponent)
})(window.KDApi)
